import { takeLatest, put, call, all } from 'redux-saga/effects';
import get from 'lodash/get';
import { enqueueSnackbarAction } from '../App/actions';
import { FESTIVALS, FESTIVAL_CONTACTS, VENUES } from '../../constants/endpointConstants';
import { create, deleteOne, updateOne } from '../../utils/API';
import { addAndUpdateFestivalContactsAction, updateFestivalInfoAction, updateFestivalVenueAction } from './actions';

export function* addAndUpdateContacts({ payload }) {
  try {
    const newContacts = get(payload, 'newContacts', []);
    const updatedContacts = get(payload, 'updatedContacts', []);
    const deletedContacts = get(payload, 'deletedContacts', []);
    const endpoint = FESTIVAL_CONTACTS(payload?.id);
    const callback = get(payload, 'callback');
    yield all([
      ...(newContacts?.length > 0 ? [call(create, endpoint, { data: newContacts })] : []),
      ...(updatedContacts?.length > 0
        ? [call(updateOne, endpoint, updatedContacts[0]?.id, { data: updatedContacts })]
        : []),
      ...deletedContacts.map(deletedContactId => call(deleteOne, endpoint, deletedContactId)),
    ]);

    if (callback && typeof callback === 'function') {
      payload.callback(updatedContacts?.length + newContacts?.length + deletedContacts?.length);
    }
    yield put(addAndUpdateFestivalContactsAction.success());
    yield put(
      enqueueSnackbarAction({
        message: `Success updating contacts`,
        options: {
          variant: 'success',
        },
      }),
    );
  } catch (err) {
    yield put(addAndUpdateFestivalContactsAction.failure());
    yield put(
      enqueueSnackbarAction({
        message: `Error updating contacts: ${err?.message}`,
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

export function* updateFestivalInfo({ payload }) {
  const callback = get(payload, 'callback');
  const id = get(payload, 'id');
  try {
    const result = yield all([
      call(updateOne, FESTIVALS, id, payload?.info),
      call(addAndUpdateContacts, {
        payload: {
          id,
          newContacts: payload?.newContacts || [],
          updatedContacts: payload?.updatedContacts || [],
          deletedContacts: payload?.deletedContacts || [],
        },
      }),
    ]);

    if (callback && typeof callback === 'function') {
      payload.callback(result[0]?.data);
    }
  } catch (err) {
    yield put(
      enqueueSnackbarAction({
        message: `Error updating festival info: ${err?.message}`,
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

export function* updateFestivalVenue({ payload }) {
  const callback = get(payload, 'callback');
  const venues = get(payload, 'venues', []);
  try {
    yield all(venues?.map(v => call(updateOne, VENUES, v?.id, v)));
    if (callback && typeof callback === 'function') {
      payload.callback();
    }
    yield put(
      enqueueSnackbarAction({
        message: `Success updating venue`,
        options: {
          variant: 'success',
        },
      }),
    );
  } catch (err) {
    yield put(
      enqueueSnackbarAction({
        message: `Error updating festival info: ${err?.message}`,
        options: {
          variant: 'error',
        },
      }),
    );
  }
}

export default function* festivalSaga() {
  yield takeLatest(addAndUpdateFestivalContactsAction.TRIGGER, addAndUpdateContacts);
  yield takeLatest(updateFestivalInfoAction.TRIGGER, updateFestivalInfo);
  yield takeLatest(updateFestivalVenueAction.TRIGGER, updateFestivalVenue);
}
